import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { ThemeUtilities } from '../../../theme';
import { CheckboxState, Size, Status } from './types';
import { fontSmoothing } from '../../../mixins';

export const CheckboxWrapper = styled.div<{
  size: Size;
  variant: CheckboxState;
  isChecked: boolean;
}>`
  display: flex;
  box-sizing: border-box;
  svg {
    visibility: hidden;
  }
  ${({ isChecked }) =>
    isChecked &&
    css`
      && svg {
        visibility: visible;
      }
    `};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Checkbox', 'size'))};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Checkbox', 'variant'))};
`;

export const Label = styled.label<{ isDisabled: boolean; status: Status }>`
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  cursor: pointer;
  user-select: none;
  ${fontSmoothing};

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
    `};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Checkbox', 'label'))};
`;
